import React from "react";
import { PermanencePreset } from "../../types";
import "./PermanenceTimePicker.css";

type PermanenceTimePickerProps = {
  label: string;
  preset: PermanencePreset;
  custom: { days: number | string; hours: number | string; minutes: number | string };
  onPresetChange: (preset: PermanencePreset) => void;
  onCustomChange: (custom: { days: number | string; hours: number | string; minutes: number | string }) => void;
  disabled?: boolean;
};

const PRESET_OPTIONS: { value: PermanencePreset; label: string }[] = [
  { value: "30min", label: "30 min" },
  { value: "1h", label: "1h" },
  { value: "12h", label: "12 h" },
  { value: "24h", label: "24 h" },
  { value: "custom", label: "Personalizado" },
];

const PermanenceTimePicker = ({
  label,
  preset,
  custom,
  onPresetChange,
  onCustomChange,
  disabled = false,
}: PermanenceTimePickerProps) => {
  const handleCustomFieldChange = (field: "days" | "hours" | "minutes", rawValue: string) => {
    let newValue: string | number = rawValue;
    if (rawValue !== "") {
      const parsed = Number(rawValue);
      newValue = Number.isNaN(parsed) ? 0 : parsed;
    }
    onCustomChange({ ...custom, [field]: newValue });
  };

  return (
    <div className="permanenceTimePicker">
      <span className="permanenceTimePickerLabel">{label}</span>
      <div className="permanenceTimePickerPills">
        {PRESET_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            className={`permanenceTimePickerPill ${preset === option.value ? "selected" : ""} ${disabled ? "disabled" : ""}`}
            onClick={() => onPresetChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <div className="permanenceTimeCustomRow">
          <div className="permanenceTimeCustomBox">
            <input
              type="number"
              min={0}
              disabled={disabled}
              value={custom.days}
              onChange={(e) => handleCustomFieldChange("days", e.target.value)}
            />
            <span>días</span>
          </div>
          <div className="permanenceTimeCustomBox">
            <input
              type="number"
              min={0}
              disabled={disabled}
              value={custom.hours}
              onChange={(e) => handleCustomFieldChange("hours", e.target.value)}
            />
            <span>horas</span>
          </div>
          <div className="permanenceTimeCustomBox">
            <input
              type="number"
              min={0}
              disabled={disabled}
              value={custom.minutes}
              onChange={(e) => handleCustomFieldChange("minutes", e.target.value)}
            />
            <span>min</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PermanenceTimePicker;
